import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const customerHistoryStyle = StyleSheet.create({
    mainView: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    firstOuterView: {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        marginHorizontal: 15,
        overflow: "hidden", marginTop: 10
    },
    detailsOuterView: {
        backgroundColor: appColors?.light,
        padding: 5,
        marginVertical: 10,
        alignItems: "center",
        borderRadius: 15,
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap"
    },
    detailsInnerView: {
        flexDirection: "row",
        alignItems: "center",
        marginHorizontal: 5,
    },
    profileView: {
        borderRadius: 100,
        backgroundColor: appColors?.primary,
        marginRight: 15,
        justifyContent: "center",
        alignItems: "center"
    },
    orderHistoryOuterView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginVertical: 5,
        borderRadius: 5
    },
    badgeTextStyle: {
        fontSize: fontSize?.smallerFontSize,
        color: appColors?.dark,
        fontFamily: appFonts?.bold
    },
    sectionOuterView: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginVertical: 10,
        borderWidth: 0.3,
        borderColor: appColors?.labelColor,
        padding: 15,
        borderRadius: 5,
        flexWrap: "wrap"
    },
    sectionInnerView: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10
    },
    accountSectionView: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        flex: 0.2
    }
})